export default __webpack_public_path__ + "static/media/H'Wear Front Right.faf4a22c.jpg";